import React, { useEffect, useState } from 'react';
import { Menu } from 'antd';
import Help from '../Help';
import Approval from '../Approval';
import Avatar from '../Avatar';
import APP_ROUTE from 'constant/route';
import { useDispatch, useSelector } from 'react-redux';
import { push } from 'connected-react-router';
import { useLocation, useHistory } from 'react-router-dom';
import qs from 'qs';
import WithEmbededWrapper from 'component/WithEmbededWrapper';
import styles from './index.module.scss';
import { RootState } from 'model';
import { RedirectPage } from 'util/meeting';
import tracker from 'lib/tracker';

interface IProps {}

interface MenuItem {
  key: string;
  route: string;
  label: string;
}

const menuItems: MenuItem[] = [
  {
    key: 'meeting',
    route: APP_ROUTE.SCHEDULE,
    label: '会议日程'
  },
  {
    key: 'room',
    route: APP_ROUTE.HOME,
    label: '会议室'
  },
  {
    key: 'contact',
    route: APP_ROUTE.CONTACT,
    label: '通讯录'
  }
];

const ExceptRoutes = [APP_ROUTE.HELP, APP_ROUTE.APPROVALCENTER];

function getSelectedKey() {
  const location = useLocation();
  const query = qs.parse(location.search.slice(1));
  const defaultKey = (menuItems.find((d) => d.route === location.pathname) || {}).key;

  if (query.from === RedirectPage.SCHEDULE) {
    return 'meeting';
  }

  if (ExceptRoutes.includes(location.pathname)) {
    return '';
  }

  return defaultKey || 'meeting';
}

const Navigation: React.FC<IProps> = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const [selectedKey, setSelectedKey] = useState<string>(getSelectedKey());
  const pathname = useSelector((state: RootState) => state.router.location.pathname);

  const handleMenuClick = (props: any) => {
    const item = menuItems.find((d) => d.key === props.key) as MenuItem;
    dispatch(push(item.route));
    setSelectedKey(props.key);
    tracker?.reporteWebMenuView(item.label);
  };

  const handleHomeClick = () => {
    dispatch(push(APP_ROUTE.SCHEDULE));
    setSelectedKey('meeting');
  };

  const handleFeedbackClick = () => {
    history.push('/help');
    setSelectedKey('');
  };

  const handleApprovalCenterClick = () => {
    history.push(APP_ROUTE.APPROVALCENTER);
    setSelectedKey('');
  };

  useEffect(() => {
    // 监听路由变化 调整选中的tab
    const item = menuItems.find((d) => d.route === pathname);
    if (!item || item.key === selectedKey) {
      return;
    }
    setSelectedKey(item.key);
  }, [pathname]);

  useEffect(() => {
    if (pathname === '/') {
      dispatch(push(menuItems[0].route));
      setSelectedKey(menuItems[0].key);
    }
  }, []);

  return (
    <div className={styles.warp}>
      <div className={styles.menus}>
        <div className={styles.title} onClick={handleHomeClick}>
          会议预约系统
        </div>
        <Menu mode="horizontal" onClick={handleMenuClick} selectedKeys={[selectedKey]} style={{ width: '100%' }}>
          {menuItems.map((item) => (
            <Menu.Item key={item.key} className={styles.menuItem}>
              {item.label}
            </Menu.Item>
          ))}
        </Menu>
        <div className={styles.side}>
          <Help onClick={handleFeedbackClick} />
          <Approval onClick={handleApprovalCenterClick} />
          <Avatar />
        </div>
      </div>
    </div>
  );
};

export default WithEmbededWrapper(Navigation);
